import { render, staticRenderFns } from "./DeliveryFirmsShell.vue?vue&type=template&id=24f42a20"
import script from "./DeliveryFirmsShell.vue?vue&type=script&lang=js"
export * from "./DeliveryFirmsShell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports